<section class="app-finder-result-container px-4 pb-4 pt-5">
  <div class="mb-4 text-base font-semibold">App Finder</div>

  @if (apps().length || collections().length) {
    <ul class="m-0 list-none space-y-5 p-0">
      @for (item of appsAndCollectionsFinderSorted(); track item.id) {
        @if (!!convertToAppInterface(item).appId) {
          <li class="before:content-none pl-0">
            <app
              [app]="convertToAppInterface(item)"
              [showAddRemoveButton]="false"
              [clickOnAppBehavior]="ClickOnAppBehavior.OPEN_APP_DETAILS"
            ></app>
          </li>
        }
        @else {
          <li class="before:content-none pl-0">
            <collection-finder-item
              [collectionFinderData]="convertToCollectionInterface(item)"
              [displayType]="DisplayType.SMALL"
              [clickOnAppBehavior]="ClickOnAppBehavior.OPEN_APP_DETAILS"
            ></collection-finder-item>
          </li>
        }
        
      }
    </ul>
  }
</section>
